import { Box, Grid } from "@mui/material";
import { useState, useEffect } from "react";

import ModalTrigger from "../Common/ModalTrigger";
import ButtonsSelect from "../Common/ButtonsSelect";

import csv5 from "../../Data/MANCP/FoodProduct/MANCP-Results-with-quantified-residues-legal-limit-legal-limit-and-non-compliant-Processed.csv";
import csv6 from "../../Data/MANCP/FoodProduct/MANCP-Results-with-quantified-residues-legal-limit-legal-limit-and-non-compliant-Unprocessed.csv";

import HorizontalBarChartWithNegative from "../Charts/HorizontalBarChartWithNegative";

const ProcessedFoodProducts = (props) => {
  const [processedFoodCSV, setProcessedFoodCSV] = useState(csv5);
  const [processedStatus, setProcessedStatus] = useState(0);

  const handleButtonClick = (event) => {
    setProcessedStatus(event);
    if (event === 0) {
      setProcessedFoodCSV(csv5);
    } else {
      setProcessedFoodCSV(csv6);
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 900);
    }

    window.addEventListener("resize", handleResize);
    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });

  const fields = [
    "Below quantification limit %",
    "Between quantification limit and Legal Limit %",
    "Above Legal Limit %",
    "Non-compliant %",
  ];
  const colorMap = {
    "Below quantification limit %": "#688E31",
    "Between quantification limit and Legal Limit %": "#BDC85A",
    "Above Legal Limit %": "#F9B112",
    "Non-compliant %": "#D77C47",
  };

  const retained = "Food commodity";

  return (
    <Grid
      item
      container
      direction="column"
      sx={{
        marginTop: { xs: "100px", sm: "100px", md: "90px" },
      }}
      alignContent="center"
    >
      <Grid
        item
        xs
        sx={{
          paddingRight: { xs: "24px", sm: "24px", lg: "24px" },
          paddingLeft: { xs: "20px", sm: "20px", lg: "20px" },
        }}
        className="six-one"
      >
        <Box className="sixth-one-inner">
          <h3>Results for processed food products</h3>
          <p className="paragraph">
           Of the 132,793 total samples, 11,167 samples (8.4%) were reported as processed food (excluding 1,504 samples of baby food). Compliance of these products is checked against the MRL in the raw agricultural commodity after applying a{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="processing factor"
            />
            . In 512 samples (5.6%), residues exceeding the MRL were found, of which 279 samples (3.1%) were non-compliant due to measurement uncertainty.
          </p>

          <p className="paragraph">
            The processed food products with a non-compliance rate higher than 10% and more than 10 samples reported were: grape leaves and similar species mainly canned/jarred and salted (39%), camomile flowers (18.2%), dried celery leaves (15.8%), dried basil and mint (15.8%), dried parsley (15.0%), processed dried beans (13.3%), dried liquorice (12.5%), coriander seed (12.5%), processed chards/beet leaves (11.8%), processed cumin seed (11.3%) and soyabeans oil (10.9%).
          </p>
          <p className="paragraph">
            Of the total number of samples, 90.5% were unprocessed food products (120,122 samples). Out of these, 3.7% (4,417) of samples had residues exceeding the MRL, of which 2.0% (2,406) of samples were non-compliant due to measurement uncertainty. The unprocessed food products with a non-compliance rate higher than 10% and more than 100 samples reported were: grape leaves and similar species (20.2%), cumin seed (12.9%), pitahaya (dragon fruit) (12.1%) and chili peppers (11.0%).
          </p>
        </Box>
      </Grid>
      <Grid
        item
        xs
        sx={{ paddingLeft: { xs: "10px", sm: "10px", md: "24px" } }}
        className="six-two"
      >
        <Box>
          <Box>
            <ButtonsSelect
              firstButton="Processed"
              secondButton="Unprocessed"
              onButtonClick={handleButtonClick}
            />
          </Box>
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "column", md: "row" }}
          >
            <Box flexGrow={3} order={{ xs: 2, sm: 2, md: 1 }}>
              <HorizontalBarChartWithNegative
                title={
                  "Results with quantified residues ≤legal limit, >legal limit and non-compliant"
                }
                height={1200}
                padding={isMobile ? [10, 20, 250, 35] : [15, 200, 60, 300]}
                marginRight={isMobile ? "auto" : "180px"}
                colorMap={colorMap}
                fields={fields}
                retained={retained}
                csv={processedFoodCSV}
              />
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ProcessedFoodProducts;
